export const svgIcons: string[] = [
  'google',
];
